import { Space, Dropdown } from 'antd';
import { useAccount } from '../../components/contexts/AccountContextManager';
import UserAvatar from '../../components/UserAvatar';
import ConsoleAvatarMenu from './ConsoleAvatarMenu';
import ConsoleCompanyMenu from './ConsoleCompanyMenu';
import ConsoleDealerMenu from './ConsoleDealerMenu';
import { Action } from './ui';

const ConsoleRightContent = () => {
    const user = useAccount(true);

    return (
        <Space size={10}>
            <ConsoleCompanyMenu />
            <ConsoleDealerMenu isDisplay />
            <Dropdown overlay={<ConsoleAvatarMenu />}>
                <Action>
                    <UserAvatar user={user} />
                </Action>
            </Dropdown>
        </Space>
    );
};

export default ConsoleRightContent;
